<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="copyright"><span class="copyright1">  </span></p>
<p class="credit"><span class="credit1">Co<a id="x.276"></a>ntent Editor: </span><span class="credit1">Caitlin Ridings</span></p>
<p class="credit"><span class="credit1">Assistant Editor</span><span class="credit1">: Adriana Fitch</span><span class="credit1"></span></p>
<p class="credit"><span class="credit1">Project Editor: </span><span class="credit1">Sarah Bozone</span><span class="credit1"></span></p>
<p class="credit"><span class="credit1">Graphic Design: </span><span class="credit1">Chris Gilbert</span><span class="credit1"></span></p>
<p class="credit"><span class="credit1">Cover Design: </span><span class="credit1">Michael Buckingham</span><span class="credit1"></span></p>
<p class="copyright"><span class="copyright1"> </span></p>
<p class="copyright2"><span class="copyright1">About the Author</span></p>
<p class="italic-copyright"><span class="itlaic-copyright">Ann Hazelwood is a former shop owner and native of St. Charles Missouri. She's always adored quilting and is a certified quilt appraiser. She's the author of the wildly successful Colebridge Community series and considers writing one of her greatest passions. Titles include: Colebridge Community series - The Basement Quilt, The Potting Shed Quilt, The Funeral Parlor Quilt, The Jane Austen Quilt Club, The Ghostly Quilts on Main, Quilted Lilies, A Colebridge Quilted Christmas.  She has also published the Wine Country Quilt Series, East Perry County series and is now writing the Door County Quilt series.</span><span class="copyright1"></span></p>
<p class="copyright"><span class="copyright1"> </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// forgiv_ebook1.vue?2fca5ba9